import { useCallback } from "react";
import { useUser, AuthClient } from "../internal/AuthClient";

export const useGetAccessToken = () => {
  const user = useUser();

  return useCallback(async () => {
    if (!user) {
      return undefined;
    }

    return AuthClient.getAccessTokenSilently();
  }, [user]);
};
